module.exports = __webpack_public_path__ + "static/media/sofa.f56a554c.svg";